(function ($, Drupal, drupalSettings) {
	'use strict';

	var initialized = false;

	Drupal.behaviors.mainEcoparc = {
		attach: function(context, setting){
			if (!initialized) {
				initialized = true;
				Drupal.behaviors.mainEcoparc.init();
			}
		},
		init:function(){

			// Prevent issue with html margin top calc for browser update.
			setTimeout(function() {
				if ($('#buorg').length) {
					$('#buorg').show();
				}
			}, 500);


			// homepage video
			if ($('a.id_embedVideo').length) {
				$('a.id_embedVideo').id_embedVideo();
			}

			// tabs
			if ($('.tabs-wrapper').length) {
				$('.tabs-wrapper').id_tabs({
					'handleHistory': true
				});
			}

			// input + textareas placeholders
			if ($('input').length || $('textarea').length) {
				!$('input, textarea, select').not('#edit-need-a-car, #rdv_point').id_placeholder();
			}

			// inject animation div for Material rollover effect in yellow bg links
			this.injectMaterialDiv($('.bg-yellow-link'));
			this.injectMaterialDiv($('button[type="submit"]'));

			// manage radio buttons for form
			if ($('.id-radio').length) {
				$('.id-radio').id_radiocheckbox({
					'multiple': false,
					'fakeElement': 'id-fake-radio',
					'firstChecked': true,
					callback: function () {
						const $context = $('.radio-context[data-value="'+ this.value +'"]');
						if ($context.length) {
							$('.radio-context').hide();
							$context.fadeIn();
						}
					}
				});
			}

			$('#edit-way--wrapper label.form-check-label').mouseover(function() {
			  var $parent = $(this).parent();
			  var $input = $parent.find('input');
			  var $value = $input.val();

        const $help = $('.suffix_registration[data-way="'+ $value +'"]');
        if ($help.length) {
          $('.suffix_registration').hide();
          $help.fadeIn();
        }
      }).mouseleave(function(){
        $('.suffix_registration').hide();
      });

		},

		injectMaterialDiv:function ($div) {
			if ($div.length) {
				$('<div class="material-animation"></div>').prependTo($div);
			}
		}


	};
})(jQuery, Drupal, drupalSettings);


